import {Card, CardBody, CardFooter, CardHeader, CardProps, Flex, Heading, LinkBox, Text, VStack} from "@chakra-ui/react"
import {BarWithDeals, sortedDealsNullable} from "../../interfaces/Bar"
import {IDeal} from "../../interfaces/IDeal"
import {CardSubtitle} from "react-bootstrap";
import DealView from "./DealView";
import {ReactNode} from "react";
import {LinkOverlayToDealOwner} from "./LinkOverlayToDealOwner";
import {LastUpdated} from "../LastUpdated";
import {ContributeMenu} from "./widget/ContributeMenu";
import {calculateDistance, useGeolocation} from "../tools/useGeolocation";
import DistanceView from "./widget/DistanceView";

export interface Props extends CardProps {
    bar: BarWithDeals,
    children?: ReactNode|undefined
}

export default function BarCard(props: Props) {
    const {location} = useGeolocation()
    return (
        <Card variant="elevated" {...props} size="sm" h="100%" p={2}>
            <LinkBox>
                <CardHeader>
                    <Flex justifyContent="space-between" alignContent="top">
                        <LinkOverlayToDealOwner owner={props.bar}>
                            <VStack align="start" m={2}>
                                <Heading size='md'>{props.bar.name}</Heading>
                                <CardSubtitle><Text color="teal.500">{props.bar.address}</Text></CardSubtitle>
                            </VStack>
                        </LinkOverlayToDealOwner>
                        <ContributeMenu dealOwner={props.bar}/>
                    </Flex>
                </CardHeader>
                <LinkOverlayToDealOwner owner={props.bar}>
                    <CardBody>
                        <Flex gap={2} direction="row" flexWrap="wrap">
                            {sortedDealsNullable(props.bar)?.map((deal: IDeal) =>
                                <DealView key={deal.description + JSON.stringify(deal.days)} deal={deal} flexGrow={1}/>
                            )}
                        </Flex>
                    </CardBody>
                    <CardFooter>
                        <Flex direction="column" align="end" w="100%">
                            { props.bar.location && location && <DistanceView distance={calculateDistance(props.bar.location, location)} bar={props.bar}/> }
                            { props.bar.updated_at && <LastUpdated updatedAt={props.bar.updated_at}/> }
                        </Flex>
                    </CardFooter>
                </LinkOverlayToDealOwner>
            </LinkBox>
        </Card>
    )
  }